import { render, staticRenderFns } from "./HomeRecepcionista.vue?vue&type=template&id=739b90a5&scoped=true"
import script from "./HomeRecepcionista.vue?vue&type=script&lang=js"
export * from "./HomeRecepcionista.vue?vue&type=script&lang=js"
import style0 from "./HomeRecepcionista.vue?vue&type=style&index=0&id=739b90a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739b90a5",
  null
  
)

export default component.exports